const calcular_resultados_finais_por_aluno = [
  {
    path: "/calcular-resultados-finais-por-aluno",
    name: "calcular_resultados_finais_por_aluno",
    meta: {
      allowedPermissions: ["resultadosfinais_calcular_media_final_aluno"],
      breadCrumb: "Processo de Resultado Final - Cálculo Resultados Finais",
    },
    component: () =>
      import(
        "@/views/CalcularResultadosFinaisPorAluno/CalcularResultadosFinaisPorAluno.vue"
      ),
  },
];

export { calcular_resultados_finais_por_aluno };
